<template>
    <v-dialog v-model="shows" v-bind="{ ...$attrs, width, maxWidth }" content-class="rounded-lg" eager>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>

        <v-sheet class="fill-height">
            <v-layout column fill-height>
                <bottom-sheet-header style="position: relative">
                    {{ title }}
                    <v-btn small text fab tile absolute right color="white" @click="shows = false"> <v-icon>mdi-close</v-icon> </v-btn>
                </bottom-sheet-header>
                <div class="scroll-primary" style="flex: 1 1 auto; overflow-y: auto">
                    <v-sheet class="pa-40 pa-lg-60">
                        <template v-if="$scopedSlots['default']">
                            <slot />
                        </template>
                        <div class="v-btn-group" v-if="!hideActions">
                            <v-btn v-bind="{ loading }" outlined color="grey-d" class="min-w-140px min-w-lg-160px" @click="exec_exit">
                                <span class="grey-6--text"> {{ text_exit }} </span>
                            </v-btn>
                            <v-btn v-bind="{ loading }" color="primary" class="min-w-140px min-w-lg-160px" @click="exec_next">
                                <span>{{ text_next }}</span>
                            </v-btn>
                        </div>
                    </v-sheet>
                </div>
            </v-layout>
        </v-sheet>
    </v-dialog>
</template>

<script>
import BottomSheetHeader from "@/components/dumb/bottom-sheet-header.vue";

export default {
    components: {
        BottomSheetHeader,
    },
    props: {
        value: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },

        exit: { type: Function, default: null },
        next: { type: Function, default: null },

        title: { type: String, default: "처리하기" },
        text_exit: { type: String, default: "취소하기" },
        text_next: { type: String, default: "계속하기" },

        hideActions: { type: Boolean, default: false },

        width: { type: [String, Number], default: "100%" },
        maxWidth: { type: [String, Number], default: 640 },
    },
    data: () => ({
        shows: false,
    }),
    methods: {
        async sync() {
            this.shows = this.value;
        },

        async exec_exit() {
            if (this.exit) {
                await this.exit();
                this.shows = false;
                return;
            }

            this.$emit("exit");
            this.shows = false;
        },

        async exec_next() {
            if (this.next) {
                await this.next();
                this.shows = false;
                return;
            }

            this.$emit("next");
        },
    },
    watch: {
        shows() {
            this.$emit("input", this.shows);
        },
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>